__turbopack_context__.v({
  "blogDestaques": "_5O78fG_blogDestaques",
  "containerDestaques": "_5O78fG_containerDestaques",
  "contentDestaque": "_5O78fG_contentDestaque",
  "imgDestaque": "_5O78fG_imgDestaque",
  "itemDestaque": "_5O78fG_itemDestaque",
  "title": "_5O78fG_title",
});
